import React, { PropsWithChildren } from 'react';
import { IUEvent } from '../../lib/event';
import styled from 'styled-components';

import { BigImage, BigImagePlaceholder } from '../Create/GeneratedImageSelection';

import { DeviceQueries } from 'Common/src/components/styled';
import EventDetailsModule from './EventDetailsModule';
import { parseHyperlinks } from '../../util/links';
import { DesktopShow, MobileShow } from '../../components/styled/Common';

const TopModule = ({ event, forSampleInvite, isAttending, children }: PropsWithChildren<{
  event: IUEvent,
  forSampleInvite?: boolean,
  isAttending: boolean
}>) => {
  const description = event.description.split('\n')
    .map((str: string, i: number) => <div key={i}>{parseHyperlinks(str)}<br/></div>);

  return <EventInfoContainer $forSampleInvite={forSampleInvite}>
    <LeftColumn $forSampleInvite={forSampleInvite}>
      {event.photoUrl !== undefined
        ? <BigImage src={event.photoUrl} $fullWidth={true}/>
        : <BigImagePlaceholder $fullWidth={true}/>}
      <DesktopShow>{children}</DesktopShow>
    </LeftColumn>
    <RightColumn $adjustMarginTop={children !== undefined}>
      <TopContent>
        <Title>
          {event.title}
        </Title>
        <MobileShow>{children}</MobileShow>
      </TopContent>
      {event.description.trim() !== '' &&
          <Description>
            {description}
          </Description>}
      <EventDetailsModule event={event} readOnly={forSampleInvite} isAttending={isAttending}/>
    </RightColumn>
  </EventInfoContainer>
};

const Title = styled.div`
  font-weight: 600;
  font-size: 40px;
  line-height: 46px;
  margin-bottom: 4px;

  @media (${DeviceQueries.mobile}) {
    margin-top: 10px;
    font-size: 22px;
    line-height: 26px;
    text-align: center;
  }
`;

const EventInfoContainer = styled.div<{ $forSampleInvite?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;

  @media (${DeviceQueries.mobile}) {
    flex-direction: column;
  }

  ${({ $forSampleInvite }) => $forSampleInvite && 'color: white;'}
`

const LeftColumn = styled.div<{ $forSampleInvite?: boolean }>`
  @media not (${DeviceQueries.mobile}) {
    ${({ $forSampleInvite }) => !$forSampleInvite && 'width: 50%;'}
  }
`

const RightColumn = styled.div<{ $adjustMarginTop: boolean }>`
  display: flex;
  padding: 0 30px;
  flex-direction: column;
  justify-content: center;
  gap: 10px;

  @media not (${DeviceQueries.mobile}) {
    // subtract height of action buttons under image to center with image
    ${({ $adjustMarginTop }) => $adjustMarginTop && 'margin-top: -50px;'}
    width: 50%;
    flex-grow: 1;
  }

  @media (${DeviceQueries.mobile}) {
    padding: 0;
  }
`

const Description = styled.div`
  font-size: 18px;
  font-weight: 400;
  word-break: break-word;

  a, a:visited {
    color: #FFF;
  }

  @media (${DeviceQueries.mobile}) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const TopContent = styled.div`
`

export default TopModule;
